// TODO: write some explanation on this file.
const TYPINGS_IMPORTED = true;
export { TYPINGS_IMPORTED };